<form class="popupForm" style="min-height: 200px;">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between top">
      {{ props.title }}
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke" style="display: flex !important;">
      <p [innerHTML]="props.message">
      </p>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
      <button mat-button *ngIf="props.cancelLabel" class="cancel widerButton font16" (click)="onNoClick()">
        {{props.cancelLabel}}
      </button>
      <button *ngIf="props.actionLabel" type="submit" class="widerButton font16" mat-raised-button color="accent" (click)="handleSubmit()">
        {{props.actionLabel}}
      </button>
    </div>
  </div>
</form>
